import type { OnboardingDetails } from './model';
import type { OnboardingDetailsDto } from './dto';

export function mapModelToDto(onboardingDetails: OnboardingDetails): OnboardingDetailsDto {
  return {
    role: onboardingDetails.role,
    account_type: 'unknown',
    phone_number: onboardingDetails.phoneNumber || undefined,
    subscribe_to_newsletter: onboardingDetails.subscribeToNewsletter,
    consent_to_parent_company_rules: Boolean(onboardingDetails.consentToParentCompanyRules),
    organization: onboardingDetails.organizationName,
    organization_size: onboardingDetails.organizationSize,
    country: onboardingDetails.country,
    website: '',
    address: '',
    partnerstack_partner_key: onboardingDetails.partnerStackKey,
    expertise: onboardingDetails.expertise,
    goal: onboardingDetails.goal,
  };
}
